import { ActionTree } from 'vuex';
import { momentTZ } from '@/helpers/moment';
import { RootState } from './types';
import { StoreState } from '@/types';
import billingAPI from '@/services/billing';
import accountsAPI from '@/services/accounts';
import { Package } from '@/models/package';
import { Address } from '@/models/address';
// import { getParameterByName } from '@/helpers/url'
// import { load } from '@/helpers/storage';

import { NSLog } from '@/helpers/log';
import { save, load } from '@/helpers/storage';
import OrderHelpers from '@/models/order';
const log = NSLog('store/root/action');

const actions: ActionTree<RootState, StoreState> = {
  async init({ commit, dispatch, rootGetters }) {
    let resErr = null;

    // init configPre - initialize config used by other modules
    await dispatch('config/initPre');

    await dispatch('auth/init');

    // ==================================================================================== \\
    // ================================== init nav store ================================== \\
    // ==================================================================================== \\
    try {
      await dispatch('nav/init');
    } catch (err) {
      resErr = err;
    }

    await dispatch("authenticated");

    const acc = load('root/global_selected_account');
    if (acc) { dispatch('setGlobalSelectedAccount', acc); }

    await dispatch('config/initPost');
    if (resErr) {
      throw resErr;
    }

    commit('clearState');
  },

  async authenticated({ dispatch, rootGetters }) {
    if (rootGetters['auth/authenticated']) {
      await dispatch('loadPackages');
      await dispatch('loadViews');
      await dispatch('loadSalesAgents');
      await dispatch('loadServiceMatrices');
      await dispatch('loadWarehouses');
    }
  },

  async newOrder({ commit, dispatch }) {
    dispatch('nav/newOrder');
  },

  async loadPackages({ commit }) {
    try {
      commit('setState', 'Loading Packages');
      commit('setPackageGroups', await billingAPI.getPackages());
      commit('setPackages');
    } catch (err) {
      throw err;
    }
    commit('clearState');
  },

  async loadViews({ commit }) {
    try {
      commit('setState', 'Loading Views');
      commit('setViews', await billingAPI.getViews());
    } catch (err) {
      throw err;
    }
    commit('clearState');
  },

  async loadSalesAgents({ commit }) {
    try {
      commit('setState', 'Loading Sales Agents');
      commit('setSalesAgents', await accountsAPI.listSalesAgents());
    } catch (err) {
      throw err;
    }
    commit('clearState');
  },

  async loadServiceMatrices({ commit }) {
    try {
      commit('setState', 'Loading Service Matrices');
      commit('setServiceMatrices', await billingAPI.listServiceMatrices());
    } catch (err) {
      throw err;
    }
    commit('clearState');
  },

  async loadWarehouses({ commit }) {
    try {
      commit('setState', 'Loading Warehouses');
      commit('setWarehouses', await billingAPI.listWarehouses());
      commit('setState', 'Loading Warehouse Packages');
      commit('setWarehousePackages', await billingAPI.listWarehousePackages());
      
    } catch (err) {
      throw err;
    }
    commit('clearState');
  },

  async setGlobalSelectedAccount({ commit, dispatch }, acc?: Account) {
    save('root/global_selected_account', acc);
    commit('setGlobalSelectedAccount', acc);
  },

  reload({ commit }) {
    commit('setState', 'Reloading');
    window.location.href = window.location.href + '';
    window.location.reload();
  },
};

export default actions;
